import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';
import { RequestLoginToolComponent } from './components/request-login-tool/request-login-tool.component';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

const PublicComponents = [
  { name: 'RequestLoginTool', type: RequestLoginToolComponent }
];

@NgModule({
  declarations: [RequestLoginToolComponent],
  exports: [RequestLoginToolComponent],
  imports: [SharedModule, CommonModule, JssModule,  ReactiveFormsModule]
})
export class PublicModule {}

export { PublicComponents };
